/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  selectKfa,
  getCurrentHypothesis,
  selectDraftVersion,
  selectClientVersion,
} from 'features/hypotheses/hypothesisSlice';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getFakeClientUser } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import useIsMountedRef from 'common/hooks/useIsMountedRef';
import useVersionToggle from 'common/hooks/useVersionToggle';
import { useIsPreviousVersionSelected } from 'common/hooks/useIsPreviousVersionSelected';
import { CommentingProps } from '../types';
import CommentingMFE from '../inlineCommenting/index';

export const KFAInlineCommenting = (props: CommentingProps) => {
  const { projectId } = useParams<{
    hypothesisId: string;
    projectId: string;
  }>();
  const isMountedRef = useIsMountedRef();
  const draftVersion = useSelector(selectDraftVersion);
  const sharedVersion = useSelector(selectClientVersion);
  const isFakeClientUser = useSelector(getFakeClientUser);
  const { isEntitySharedWithClient } = useVersionToggle(
    isMountedRef.current,
    draftVersion,
    sharedVersion
  );
  const isPreviousVersionSelected = useIsPreviousVersionSelected();
  const rawKfa = useSelector(selectKfa);
  const hypothesis = useSelector(getCurrentHypothesis);
  const kfa = (rawKfa || { content: undefined }).content;
  if (kfa) {
    const contentId = hypothesis?.selectedVersion?.contentId || kfa.contentId;
    return (
      <div>
        <CommentingMFE
          {...props}
          contentId={contentId}
          isFakeClientUser={isFakeClientUser}
          projectId={projectId}
          isShared={isEntitySharedWithClient}
          isPreviousVersionSelected={isPreviousVersionSelected}
        />
      </div>
    );
  }
  return <></>;
};

export default KFAInlineCommenting;
